
import { Component, Vue, Prop } from 'vue-property-decorator';

@Component({})
export default class PriorityScoreCard extends Vue {
  @Prop({ type: Number, default: 0 }) priorityScore!: number;
  @Prop({ type: Number, default: 0 }) stockoutRiskScore!: number;
  @Prop({ type: Number, default: 0 }) revenueImpactScore!: number;
  @Prop({ type: Number, default: 0 }) leadTimeUrgencyScore!: number;
  @Prop({ type: String, default: 'Normal' }) priorityLevel!: string;
  @Prop({ type: Boolean, default: false }) compact!: boolean;

  public showBreakdown: boolean = false;

  public toggleBreakdown(): void {
    this.showBreakdown = !this.showBreakdown;
  }

  public get priorityLevelClass(): string {
    switch (this.priorityLevel.toLowerCase()) {
      case 'critical': return 'priority-critical';
      case 'high': return 'priority-high';
      case 'normal': return 'priority-normal';
      case 'low': return 'priority-low';
      default: return 'priority-normal';
    }
  }

  public get priorityLevelColor(): string {
    switch (this.priorityLevel.toLowerCase()) {
      case 'critical': return '#f6687b';
      case 'high': return '#faaf3b';
      case 'normal': return '#59C8E4';
      case 'low': return '#99be50';
      default: return '#59C8E4';
    }
  }

  public get priorityLevelIcon(): string {
    switch (this.priorityLevel.toLowerCase()) {
      case 'critical': return 'mdi-alert-octagon';
      case 'high': return 'mdi-alert-triangle';
      case 'normal': return 'mdi-information';
      case 'low': return 'mdi-check-circle';
      default: return 'mdi-information';
    }
  }
}
